import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-598450a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "side-wrapper"
};
import SideBarItem from './sideBarItem.vue';
import constantRoutes from '@/router/routes';
const __default__ = {
  name: 'Sidebar'
};
function setup(__props) {
  return (_ctx, _cache) => {
    return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(constantRoutes), item => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: item.path
      }, [item.meta?.show ? (_openBlock(), _createBlock(SideBarItem, {
        key: 0,
        "current-route": item,
        path: item.path,
        layer: 0
      }, null, 8, ["current-route", "path"])) : _createCommentVNode("", true)], 64);
    }), 128))]);
  };
}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup
});